import { createGlobalStyle } from 'styled-components';
import bgImage from '../images/background.svg'; 

const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  :root {
    --primary: #00E5FF; /* Electric Cyan */
    --secondary: #6366F1; /* Modern Indigo */
    --darkBlue: #0F172A; /* Slate 900 */
    --darkPurple: #1A0B2E;
    --black-1: #030712; /* Ultra-dark background */
    --black-2: #0B1325;
    --white-1: #F8FAFC;
    --gray: #94A3B8;
    --grey: var(--gray);
    --white: #FFFFFF;
    --black: #000000;
  }

  html {
    font-size: 10px;
    scroll-behavior: smooth;
  }

  body {
    min-height: 100vh;
    line-height: 1.6;
    width: 100%;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
    color: var(--white-1);
    -webkit-font-smoothing: antialiased;

    background-color: var(--black-1);
  }

  body::before {
    content: '';
    position: fixed;
    inset: 0;
    z-index: -1;
    pointer-events: none;
    
    background-image: 
      linear-gradient(rgba(255, 255, 255, 0.015) 1px, transparent 1px),
      linear-gradient(90deg, rgba(255, 255, 255, 0.015) 1px, transparent 1px),
      radial-gradient(circle at 15% 0%, rgba(99, 102, 241, 0.12) 0%, transparent 40%),
      radial-gradient(circle at 85% 100%, rgba(0, 229, 255, 0.1) 0%, transparent 40%),
      linear-gradient(to bottom, transparent, var(--black-1)),
      url(${bgImage});
      
    background-size: 
      60px 60px, 60px 60px,
      100% 100%, 100% 100%,
      100% 100%,            
      cover;                
    background-position: center center;
    background-repeat: no-repeat;
  }

  a {
    text-decoration: none;
    color: var(--white);
  }

  .container {
    max-width: 1200px;
    margin: 0 auto;
    width: 90%;
  }

  img,
  svg {
    height: 100%;
    width: 100%;
  }

  li,
  ul {
    list-style: none;
  }

  /* Global Animations */
  @keyframes fadeUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes glowPulse {
    0% {
      box-shadow: 0 0 5px rgba(0, 229, 255, 0.2);
    }
    50% {
      box-shadow: 0 0 20px rgba(0, 229, 255, 0.6);
    }
    100% {
      box-shadow: 0 0 5px rgba(0, 229, 255, 0.2);
    }
  }
`;

export default GlobalStyles;